import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { cls_newMemberLoan_item_width } from "./view.css";
import { cls_colorCyan70, cls_colorMagenta60, cls_cursor_pointer, cls_gap_form, cls_h5, cls_p4b, cls_p5r } from "style/index.css";
import { cls_align_items_flex_start, cls_align_items_stretch, cls_box, cls_box_vertical } from "framework/structural_components/hbox_vbox.css";
import { Button, Intent } from "framework/controls/button";
import { cls_form_area_box } from "style/form.css";
import { useUIContext } from "common/uicontext/store";
import { Select, SelectItem } from "framework/controls/select";
import { Link } from "framework/link/link";
import { LoginButton } from "common/login_dialog/login_dialog";
import { useMemberLoans } from "common/member_loans/store";
import { DateField } from "framework/controls/date_field";
import { cls_link_default_no_underline } from "framework/link/link.css";
import { getEntityField } from "framework/state/setfield";
import { getFieldErrorsAsString } from "framework/validation/validatableentity";
import { UrlPathOfPublicSection, UrlPathOfAdminSection } from "common/paths";
import { useLocation } from "wouter";
import { TextField } from "framework/controls/text_field";
import { isValidInt } from "framework/helpers";
import { useMemberLoanListAdmin } from "admin_app/member_loans/memberLoan_list_store";
var baseUrl = "".concat(UrlPathOfPublicSection, "/osobni/{idt}/hostovani");
var NewMemberLoanContent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var propsIdt = (_a = props.idt) !== null && _a !== void 0 ? _a : null;
    var propsFromAdminClubId = (_b = props.fromAdminClubId) !== null && _b !== void 0 ? _b : null;
    var propsFromSecretaryAdmin = (_c = props.fromSecretaryAdmin) !== null && _c !== void 0 ? _c : false;
    var _o = useMemberLoans(), actions = _o[1];
    var _p = useUIContext(), uiContextState = _p[0], uiContextActions = _p[1];
    var isSecretary = (_f = (_e = (_d = uiContextState.data) === null || _d === void 0 ? void 0 : _d.event_planning) === null || _e === void 0 ? void 0 : _e.isSecretary) !== null && _f !== void 0 ? _f : false;
    var _q = useMemberLoanListAdmin(), actions_memberLoanListAdmin = _q[1];
    React.useEffect(function () {
        actions.resetForm();
        uiContextActions.loadEventRegistrationUIContextWithDate(new Date());
        uiContextActions.loadEventPlanningUIContext();
    }, []);
    React.useEffect(function () {
        if (isSecretary === true) {
            actions.loadAllClubs();
        }
    }, [isSecretary]);
    React.useEffect(function () {
        if (propsIdt !== null) {
            actions.setNewMemberLoanEntityField('memberIdt', propsIdt);
            actions.setNewMemberLoanEntityField('hostingClubId', null);
        }
        if (propsFromAdminClubId !== null) {
            actions.setNewMemberLoanEntityField('memberIdt', null);
            actions.setNewMemberLoanEntityField('hostingClubId', propsFromAdminClubId);
        }
        if (propsFromSecretaryAdmin === true) {
            actions.setNewMemberLoanEntityField('memberIdt', null);
            actions.setNewMemberLoanEntityField('hostingClubId', null);
        }
    }, [propsIdt, propsFromAdminClubId, propsFromSecretaryAdmin]);
    var state = useMemberLoans()[0];
    React.useEffect(function () {
        if (state.newLoanForm.entity.memberIdt !== null) {
            actions.loadAthlete(state.newLoanForm.entity.memberIdt);
        }
    }, [state.newLoanForm.entity.memberIdt]);
    var ownClubs = (_j = (_h = (_g = uiContextState.data) === null || _g === void 0 ? void 0 : _g.admin_web_credentials) === null || _h === void 0 ? void 0 : _h.clubs) !== null && _j !== void 0 ? _j : [];
    var allClubs = state.clubs.collection.map(function (c) {
        return {
            clubId: c.id,
            clubName: c.name,
        };
    });
    var availableClubs = isSecretary ? allClubs : ownClubs;
    var registeredMemberLoanId = state.newLoanForm.registeredMemberLoanId;
    var memberLoanRegistrationFinished = registeredMemberLoanId !== null;
    var getterClub = function (field) {
        var _a, _b;
        return (_b = (_a = state.newLoanForm.entity.hostingClubId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
    };
    var getterDate = function (field) {
        return getEntityField(state.newLoanForm, field);
    };
    var setterClub = function (field, value, validator, storeInvalidValue) {
        return actions.setNewMemberLoanEntityField(field, parseInt(value), validator, storeInvalidValue);
    };
    var getterIdt = function (field) {
        var _a, _b;
        return (_b = (_a = state.newLoanForm.entity.memberIdt) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
    };
    var setterIdt = function (field, value, validator, storeInvalidValue) {
        if (value === "") {
            return actions.setNewMemberLoanEntityField(field, null, validator, storeInvalidValue);
        }
        else if (isValidInt(value)) {
            return actions.setNewMemberLoanEntityField(field, parseInt(value), validator, storeInvalidValue);
        }
    };
    var backlUrl = null;
    if (propsIdt !== null) {
        backlUrl = "".concat(baseUrl.replace('{idt}', propsIdt.toString()));
    }
    if (propsFromAdminClubId !== null) {
        backlUrl = "".concat(UrlPathOfAdminSection, "/klub/").concat(propsFromAdminClubId, "/hostovani");
    }
    if (propsFromSecretaryAdmin !== null) {
        backlUrl = "".concat(UrlPathOfAdminSection, "/soutezici/hostovani");
    }
    var athleteFound = state.newLoanForm.entity.memberIdt !== null
        && state.newLoanForm.entity.memberIdt === ((_k = state.athlete.entity) === null || _k === void 0 ? void 0 : _k.idt)
        && !state.athlete.loading && !state.athlete.loadFailure;
    var allInputsFilled = athleteFound
        && state.newLoanForm.entity.hostingClubId !== null
        && state.newLoanForm.entity.fromDate !== null
        && state.newLoanForm.entity.toDate !== null;
    var canBeSubmitted = allInputsFilled;
    var globalError = getFieldErrorsAsString(state.newLoanSubmission, "");
    var formControlsDisabled = state.newLoanSubmission.updating;
    var _r = useLocation(), setLocation = _r[1];
    React.useEffect(function () {
        if (memberLoanRegistrationFinished) {
            actions.resetForm();
            if (propsFromSecretaryAdmin === true) {
                actions_memberLoanListAdmin.loadData();
                setLocation("".concat(UrlPathOfAdminSection, "/soutezici/hostovani"));
            }
            else if (propsFromAdminClubId !== null) {
                actions_memberLoanListAdmin.loadData();
                setLocation("".concat(UrlPathOfAdminSection, "/klub/").concat(propsFromAdminClubId, "/hostovani"));
            }
            else if (propsIdt !== null) {
                setLocation(baseUrl.replace('{idt}', state.newLoanForm.entity.memberIdt.toString()));
            }
        }
    }, [memberLoanRegistrationFinished]);
    return React.createElement(VBox, { className: [cls_gap_form] },
        backlUrl !== null && React.createElement(HBox, null,
            React.createElement(Link, { url: backlUrl, className: [cls_box, cls_box_vertical, cls_cursor_pointer, cls_link_default_no_underline] },
                React.createElement(Button, { intent: Intent.Primary }, "Zp\u011Bt na seznam hostov\u00E1n\u00ED"))),
        React.createElement(HBox, { className: [cls_h5] }, "Registrace nov\u00E9ho hostov\u00E1n\u00ED"),
        React.createElement(HBox, null, availableClubs.length > 0 ? React.createElement(VBox, { className: [cls_form_area_box, cls_gap_form, cls_align_items_flex_start] }, memberLoanRegistrationFinished === false && React.createElement(React.Fragment, null,
            React.createElement(VBox, { className: [cls_gap_form] },
                propsIdt === null && React.createElement(VBox, { className: [cls_newMemberLoan_item_width, cls_align_items_stretch] },
                    React.createElement(TextField, { label: "IDT", name: "memberIdt", state: state.newLoanForm, getter: getterIdt, setter: setterIdt, disabled: formControlsDisabled })),
                athleteFound && React.createElement(VBox, { className: [cls_p4b, cls_colorCyan70] },
                    React.createElement(HBox, null, (_m = (_l = state.athlete.entity) === null || _l === void 0 ? void 0 : _l.name) !== null && _m !== void 0 ? _m : "")),
                React.createElement(VBox, { className: [cls_newMemberLoan_item_width, cls_align_items_stretch] },
                    React.createElement(Select, { name: "hostingClubId", label: "Do klubu", state: state.newLoanForm, getter: getterClub, setter: setterClub, disabled: propsFromAdminClubId !== null }, availableClubs.map(function (c) { return React.createElement(SelectItem, { key: c.clubId, children: c.clubName, value: c.clubId.toString() }); }))),
                React.createElement(VBox, { className: [cls_newMemberLoan_item_width, cls_align_items_stretch] },
                    React.createElement(DateField, { label: "Od data", name: "fromDate", state: state.newLoanForm, getter: getterDate, setter: actions.setNewMemberLoanEntityField, disabled: formControlsDisabled })),
                React.createElement(VBox, { className: [cls_p4b, cls_colorCyan70, cls_newMemberLoan_item_width] },
                    React.createElement(DateField, { label: "Do data", name: "toDate", state: state.newLoanForm, getter: getterDate, setter: actions.setNewMemberLoanEntityField, disabled: formControlsDisabled }))),
            allInputsFilled && React.createElement(React.Fragment, null, canBeSubmitted && React.createElement(VBox, { className: [cls_gap_form] },
                React.createElement(VBox, { className: cls_newMemberLoan_item_width },
                    React.createElement(Button, { intent: Intent.Primary, onClick: function () { return actions.submitNewMemberLoan(); }, disabled: formControlsDisabled }, "Registrovat")),
                globalError !== null && React.createElement(HBox, { className: [cls_p5r, cls_colorMagenta60, cls_newMemberLoan_item_width] }, globalError))))) : React.createElement(HBox, null, "Nem\u00E1te opr\u00E1vn\u011Bn\u00ED k \u017E\u00E1dn\u00E9mu klubu pro hostov\u00E1n\u00ED.")));
};
export var NewMemberLoan = function (props) {
    var uiContextState = useUIContext()[0];
    var userIsLoggedIn = !!uiContextState.data.logged_user;
    return React.createElement(React.Fragment, null, userIsLoggedIn ? React.createElement(NewMemberLoanContent, { idt: props.idt, fromAdminClubId: props.fromAdminClubId, fromSecretaryAdmin: props.fromSecretaryAdmin }) : React.createElement(VBox, { className: cls_gap_form },
        React.createElement(HBox, null, "Pro zobrazen\u00ED obsahu se mus\u00EDte p\u0159ihl\u00E1sit do syst\u00E9mu."),
        React.createElement(HBox, null,
            React.createElement(LoginButton, { disableMobileVersionStyle: true }))));
};
